import { FaMapMarkerAlt, FaEnvelope, FaBuilding, FaIndustry } from "react-icons/fa";

export const contactInfo = [
  {
    icon: <FaBuilding size={36} className="text-orange-500 mb-4" />,
    title: "HQ Location",
    details: <>Plot 121, 1st floor, Road 3, Kakateeyahills, Madhapur, Hyderabad, 500081, TG</>,
    phone: "+91-9666638552",
  }, {
    icon: <FaMapMarkerAlt size={36} className="text-orange-500 mb-4" />,
    title: "Branch Location",
    details: <>56-4-41, KoneruyKoneru Bulliyya Chowdary Street, Benz Circle, Vijayawada, 520010, AP</>,
    phone: "+91-8886274447",
  }, {
    icon: <FaIndustry size={36} className="text-orange-500 mb-4" />,
    title: "Manufacturing unit",
    details: <>VGP 11/514 A, Thoprankudy, P.O, Idukki, Kerala, 685609</>,
    // phone: "+91-9666638552",
  },
  {
    icon: <FaEnvelope size={36} className="text-orange-500 mb-4" />,
    title: "Email Us",
    details: (
      <>
        sales@zestytongue.com
      </>
    ),
  },
];

export const subjects = [
  "",
  "General Inquiry",
  "Product Feedback",
  "Partnership",
  "Support",
];
